export class UpdateAwsSourceAccountAttributes {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "roleArn",
            "baseName": "roleArn",
            "type": "string",
            "format": ""
        },
        {
            "name": "regions",
            "baseName": "regions",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateAwsSourceAccountAttributes.attributeTypeMap;
    }
    constructor() {
    }
}
